import InspectionDetails from "./InspectionPage";

export default InspectionDetails;
